import type { RouteObject } from "react-router-dom";
import Layout from "@/components/feature/Layout";
import Home from "@/pages/home/page";
import Category from "@/pages/category/page";
import DramaList from "@/pages/list/page";
import News from "@/pages/news/page";
import NewsDetail from "@/pages/news/detail";
import DramaDetail from "@/pages/detail/page";
import ActorDetail from "@/pages/actor/page";
import ActorsList from "@/pages/actors/page";
import Search from "@/pages/search/page";
import About from "@/pages/about/page";
import NotFound from "@/pages/NotFound";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Layout />,
    children: [
      { index: true, element: <Home /> },
      { path: "category/:type", element: <Category /> },
      { path: "list/:categoryId", element: <DramaList /> },
      { path: "news", element: <News /> },
      { path: "news/:id", element: <NewsDetail /> },
      { path: "detail/:id", element: <DramaDetail /> },
      { path: "actor/:id", element: <ActorDetail /> },
      { path: "actors", element: <ActorsList /> },
      { path: "search", element: <Search /> },
      { path: "about", element: <About /> },
      { path: "404", element: <NotFound /> },
      { path: "*", element: <NotFound /> },
    ],
  },
];

export default routes;